export default "__VITE_ASSET__YhNCc8kPC3cxGCL$BOC21A__"